import { createSelector } from "@reduxjs/toolkit";
import type { Location } from "history";
/* CIQ Edit */
import _ from "underscore";

/* CIQ Edit: remove unused getUserPersonalCollectionId import */
import {
  canonicalCollectionId,
  isLibraryCollection,
  isRootTrashCollection,
} from "metabase/collections/utils";
import * as Urls from "metabase/lib/urls/collections";
import type { Collection, CollectionId } from "metabase-types/api";
import type { State } from "metabase-types/store";

import { ROOT_COLLECTION } from "./constants";

type Props = {
  collectionId?: Collection["id"];
  location?: Location;
  params?: { collectionId?: Collection["id"]; slug?: string };
};

function byCollectionIdProp(state: State, { collectionId }: Props) {
  return collectionId;
}

function byCollectionIdNavParam(state: State, { params }: Props) {
  return params && params.collectionId;
}

function byCollectionUrlId(state: State, { params, location }: Props) {
  const isCollectionPath =
    params &&
    params.slug &&
    location &&
    Urls.isCollectionPath(location.pathname);
  return isCollectionPath && Urls.extractCollectionId(params.slug);
}

function byCollectionQueryParameter(state: State, { location }: Props) {
  return location && location.query && location.query.collectionId;
}

/* CIQ Edit: add fn to omit personal collections from list of collections */
export const omitPersonalCollections = (collections) => {
  return _.filter(collections, (c) => c.personal_owner_id === null);
};

const getInitialCollectionId = createSelector(
  [
    (state) => {
      const collections = state.entities.collections || {};
      return collections as Record<CollectionId, Collection>;
    },
    /* CIQ Edit: no personal collections */
    // getUserPersonalCollectionId,

    // these are listed in order of priority
    byCollectionIdProp,
    byCollectionIdNavParam,
    byCollectionUrlId,
    byCollectionQueryParameter, // used by new model flow
  ],
  (collections, personalCollectionId, ...collectionIds) => {
    const rootCollectionId = ROOT_COLLECTION.id as CollectionId;
    const validCollectionIds = collectionIds
      .filter((id) => !isRootTrashCollection(collections[id as CollectionId]))
      .concat(rootCollectionId) as CollectionId[];

    // CIQ Edit: Don't add personal collection to priority list
    // if (personalCollectionId) {
    //   validCollectionIds.push(personalCollectionId);
    // }

    for (const collectionId of validCollectionIds) {
      const collection = collections[collectionId];
      if (
        collection != null &&
        collection.can_write &&
        !isLibraryCollection(collection)
      ) {
        return canonicalCollectionId(collectionId);
      }
    }

    // CIQ Edit: default to first writable collection under root
    // const rootCollection = collections[rootCollectionId];
    // return rootCollection?.can_write
    //   ? canonicalCollectionId(rootCollectionId)
    //   : canonicalCollectionId(personalCollectionId);

    const rootCollection = collections[rootCollectionId];

    // CIQ Edit: Don't fall back to personal collection, use root instead
    return rootCollection?.can_write
      ? canonicalCollectionId(rootCollectionId)
      : canonicalCollectionId(rootCollectionId); // Always use root, not personal
  },
);

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default getInitialCollectionId;
